export const engagementCampaignsAggregateStatsAppGroupId = "/engagement/campaigns/aggregate_stats/:app_group_id";
